export const FETCH_BENCHMARK_GENERATION_STATUS_REQUEST =
  "FETCH_BENCHMARK_GENERATION_STATUS_REQUEST";

export const FETCH_BENCHMARK_GENERATION_STATUS_SUCCESS =
  "FETCH_BENCHMARK_GENERATION_STATUS_SUCCESS";

export const FETCH_BENCHMARK_GENERATION_STATUS_FAILURE =
  "FETCH_BENCHMARK_GENERATION_STATUS_FAILURE";

export const fetchBenchmarkGenerationStatusRequest = (payload) => ({
  type: FETCH_BENCHMARK_GENERATION_STATUS_REQUEST,
  payload,
});

export const fetchBenchmarkGenerationStatusSuccess = (data) => ({
  type: FETCH_BENCHMARK_GENERATION_STATUS_SUCCESS,
  payload: data,
});

export const fetchBenchmarkGenerationStatusFailure = (error) => ({
  type: FETCH_BENCHMARK_GENERATION_STATUS_FAILURE,
  payload: error,
});
